import React from 'react';
import Button from './Button';

const LinkButton = (props) => <Button variant="link" {...props} full={false} />;

export default LinkButton;
